import * as React from 'react';

type Props = {
  autofilled?: boolean;            // shows navy tint when value was auto-filled
  className?: string;              // additional CSS class
  children: React.ReactNode;       // usually an <input> + unit span
};

/**
 * V3SpecFieldWrap — inline editable value + unit box.
 *
 * Used in: workspace left panel — Location section ZIP/wind/snow
 * fields, Building section height fields. Pairs a small numeric
 * input with a unit label (mph, psf, ft, etc.) inside a single
 * rounded box.
 *
 * `autofilled` is set when the parent auto-populated the value from
 * an API lookup (e.g. environmental factors from ZIP via the ASCE
 * microservice). The box gets a subtle navy tint so the user knows
 * the value came from auto-fill, not manual entry.
 */
const V3SpecFieldWrap: React.SFC<Props> = ({ autofilled = false, className, children }) => (
  <div className={`v3-spec-field-wrap ${autofilled ? 'autofilled' : ''} ${className || ''}`}>
    {children}
  </div>
);

export default V3SpecFieldWrap;
